/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const UPDATEUSERSTOREINFO= createAsyncThunk(
  "updateUserStoreInfo/updateUserStoreInfo",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const updateUserStoreInfoSlice = createSlice({
  name: "updateUserStoreInfoSlice",
  initialState: {
    updateUserStoreInfo: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfupdateUserStoreInfo: (state) => {
        state.updateUserStoreInfo.loading = false
        state.updateUserStoreInfo.error = false
        state.updateUserStoreInfo.data = []
        state.updateUserStoreInfo.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(UPDATEUSERSTOREINFO.fulfilled, (state, action) => {
      state.updateUserStoreInfo = {
        ...state.updateUserStoreInfo,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEUSERSTOREINFO.pending, (state, action) => {
      state.updateUserStoreInfo = {
        ...state.updateUserStoreInfo,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(UPDATEUSERSTOREINFO.rejected, (state, action) => {
      state.updateUserStoreInfo = {
        ...state.updateUserStoreInfo,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const updateUserStoreInfoAction = {
    UPDATEUSERSTOREINFO,
};

export { updateUserStoreInfoAction };
export default updateUserStoreInfoSlice.reducer;
export const {setInitialStateOfupdateUserStoreInfo} = updateUserStoreInfoSlice.actions